<template>
  <div class="modal fade" :id="id" tabindex="-1" data-bs-backdrop="static" data-bs-keyboard="false" role="dialog" aria-labelledby="staticBackdrop" aria-hidden="true">
    <div class="modal-dialog modal-lg">
      <form @submit.prevent="submitForm" class="form">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">{{ title || $t("projectTypes.stepModalTitle") }}</h5>
            <div class="btn btn-icon btn-sm btn-active-light-primary ms-2" @click.prevent="closeModal">
                <span class="svg-icon svg-icon-1">
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                    <rect opacity="0.5" x="6" y="17.3137" width="16" height="2" rx="1" transform="rotate(-45 6 17.3137)"
                          fill="currentColor" />
                    <rect x="7.41422" y="6" width="16" height="2" rx="1" transform="rotate(45 7.41422 6)"
                          fill="currentColor" />
                  </svg>
                </span>
            </div>
          </div>
          <div class="modal-body">
            <RequiredText />
            <div class="row pb-3 mb-4">
              <Select2
                  container-class="form-group col-12 col-md-12"
                  :multiple="false"
                  :show-search="true"
                  :selectClass="'form-select form-control-sm form-select-solid'"
                  :name="`project-type-contact`+id"
                  :label="$t('projectTypes.label.step')"
                  labelClass="form-label fs-6 text-black"
                  :placeholder-text="$t('projectTypes.label.step')"
                  @update:modelValue="handleStepSelected"
                  :parent-id="`#${id}`"
                  v-model="stepFormData.milestone_category_id"
                  :IsInputGroup="$can(abilities.CREATE_CONTACT)"
                  icon="bi bi-plus"
                  :clickAddon="openStepModal">
                <option v-for="step in filterMilestones" :value="step.id" :key="step.id">
                  {{ step.title }}
                </option>
              </Select2>

              <Input
                  container-class="form-group col-12 col-md-6 mt-5 "
                  :name="`project-type-percent`+id"
                  type="number"
                  labelClass="form-label fs-6 text-black"
                  :label="$t('projectTypes.label.percent')"
                  :inputClass="'form-control form-control-lg form-control-solid'"
                  :isRequired="true"
                  size="lg"
                  :placeholder="''"
                  v-model="stepFormData.milestone_categories_progress"
                  :min="1">
                <template #rightAddon>
                  <span class="position-absolute border-0 bg-transparent end-0 top-50 translate-middle me-15">
                    %
                  </span>
                </template>
              </Input>

              <Input
                  container-class="form-group col-12 col-md-6 mt-5 "
                  :name="`project-type-delay_value`+id"
                  type="number"
                  labelClass="form-label fs-6 text-black"
                  :label="$t('projectTypes.label.delay')"
                  :inputClass="'form-control form-control-lg form-control-solid'"
                  :isRequired="false"
                  size="lg"
                  :placeholder="''"
                  v-model="stepFormData.delay_value"
                  :IsInputGroup="true"
                  :min="1">
                <template #rightAddon>
                  <Select2
                      container-class="form-group mw-100px"
                      :multiple="false"
                      :show-search="false"
                      :isRequired="false"
                      :parent-id="`#${id}`"
                      label-class="form-label fs-6 text-black"
                      :selectClass="'form-select form-control-sm form-select-solid rounded-start-0 w-100px'"
                      :name="`projectTypes-delay-unit-id`+id"
                      v-model="stepFormData.delay_unit">
                    <option v-for="(frequency, index) in recurringFrequencyEnum" :value="frequency.value" :key="index">
                      {{ frequency[locale] }}
                    </option>
                  </Select2>
                </template>
              </Input>
              <Select2
                  container-class="col-12 mt-5"
                  :show-search="true"
                  :selectClass="'form-select form-control-sm form-select-solid'"
                  :name="'project-type-status'+id"
                  :label="$t('projectTypes.label.status')"
                  labelClass="form-label fs-6 text-black"
                  :parent-id="`#${id}`"
                  :placeholderText="$t('projectTypes.label.status')"
                  v-model="statusSelected"
                  :IsInputGroup="true"
                  :is-required="false"
                  icon="bi bi-plus"
                  :clickAddon="openStatusModal" :multiple="false">
                <option v-for="status in filteredStatus" :data-id="status.id" :value="status.id" :key="status.id">
                  {{ status.title }}
                </option>
              </Select2>

              <Card  class="card my-5 p-5">
                <table class="table align-middle table-row-bordered fs-6 gy-3 gx-4" id="step-datatable" style="margin-top: 13px !important; cursor:pointer">
                  <thead>
                  <tr class="fw-bold fs-6" style="background-color: #F2F3F4;">
                    <th class="">{{ $t('projectTypes.table.order')}}</th>
                    <th class="">{{ $t('projectTypes.table.status')}}</th>
                    <th class="text-end w-50px">{{ $t('projectTypes.table.actions')}}</th>
                  </tr>
                  </thead>
                  <Sortable :id="'stepStatusSortable'" @change="handleChangeOrder">
                    <tr class="draggable" v-for="(status, index) in stepFormData.status" :key="status">
                      <td class="draggable-handle"> {{ index+1 }} </td>
                      <td class="draggable-handle"> {{ getStatusTitle(status)}} </td>
                      <td @click.prevent="deleteStatus(index)" class="text-center w-50px"> <i class="fa fa-trash"></i></td>
                    </tr>
                  </Sortable>

                </table>
              </Card>
            </div>
          </div>
          <div class="modal-footer">
            <Button type="cancel" id="cancel_btn" btn-class="btn-sm me-3" size="7px 30px" btn-text="button.cancel" @click.prevent="closeModal"></Button>
            <Button btn-class="btn-sm me-3" type="submit" id="submit_btn" btn-text="button.save" size="7px 30px" :is-loading="isLoading"></Button>
          </div>
        </div>
      </form>
    </div>
  </div>
  <StepModal id="project-step-modal" :parent="id" @stepCreated="stepCreated"/>
  <TaskStatusModal id="task-status-modal" :parent="id" @statusCreated="statusCreated"/>

</template>

<script setup>
import {ref, defineEmits, defineProps, computed, onMounted, nextTick, watch} from "vue";
import Input from "@/components/Input.vue";
import {useStore} from "vuex";
import Button from "@/components/Button.vue"
import RequiredText from "@/components/RequiredText.vue";
import Select2 from "@/components/Select2.vue";
import abilities from "@/composables/abilities";
import StepModal from "../Modals/StepModal.vue";
import TaskStatusModal from "../Modals/TaskStatusModal.vue";
import { useLocales } from "@/composables/locales";
import Sortable from "@/components/Sortable.vue";
import Card from "@/components/Card.vue";


const store = useStore()
const {locale} = useLocales()

const emits = defineEmits(['save'])
const props = defineProps({
    id: {
      type: String,
      required: true
    },
    parent: {
      type: String,
    },
    title: {
      type: String,
      default: ''
    },
    form: {
      type: Object,
      default: () => ({
        milestone_category_id: '',
        position: 1,
        milestone_category_name: '',
        milestone_categories_progress: '',
        delay_value: '',
        delay_unit: '',
        project_category_group_id: '',
        status: [],
        tasks: []
      })
    },
    edit: {
      type: Boolean,
      default: false
    },
    selectedSteps: {
      type: Array,
      default: () => []
    },
    loading: {
      type: Boolean,
      default: false
    },
})
const isLoading = ref(props.loading)

const stepFormData = ref(props.form)
const statusSelected = ref()

const milestones = computed(() => store.getters['milestoneCategories/getTaskMilestones'])
const recurringFrequencyEnum = computed(() => store.getters["configs/getFrequencyEnum"])
const taskStatus = computed(() => store.getters['taskStatus/getTaskStatus'])
const filteredStatus = computed(() =>  taskStatus.value.filter(el => !stepFormData.value?.status?.includes(el.id)))
const filterMilestones = computed(() => {
  const current = stepFormData.value.milestone_category_id;
  return milestones.value.filter(milestone => {
    return milestone.id === current || !props.selectedSteps.includes(milestone.id);
  });
})

watch(() => props.form, () => {
  stepFormData.value = props.form
})

watch(() => statusSelected.value , (value) => {
  if(value){
    statusCreated(value)
    statusSelected.value = null
  }
})

function closeModal(){
  $('#'+props.id).modal('toggle')
  stepFormData.value = {
    milestone_category_id: '',
    position: 1,
    milestone_category_name: '',
    milestone_categories_progress: '',
    delay_value: '',
    delay_unit: '',
    project_category_group_id: '',
    status: [],
    tasks: []
  }
}

function submitForm(){
  emits('save', stepFormData.value)
  closeModal()
}

function handleStepSelected(stepId) {
  if(stepId) {
    let step = milestones.value.find(el => el.id === stepId)
    stepFormData.value.milestone_categories_progress = parseInt(step?.milestone_progress)
    stepFormData.value.milestone_category_name = step?.title
    stepFormData.value.status = step?.status?.map(el => el.id)
  }
}

function openStepModal() {
  $('#'+props.id).modal('toggle')
  $('#project-step-modal').modal('toggle')
}

function stepCreated(id){
  stepFormData.value.milestone_category_id = id
  handleStepSelected(id)
}

function openStatusModal() {
  $('#'+props.id).modal('toggle')
  $('#task-status-modal').modal('toggle')
}

function statusCreated(id){
  stepFormData.value.status.push(id)
}

function handleChangeOrder({ oldIndex, newIndex }) {

  const data = stepFormData.value.status

  const itemToMove =data[oldIndex];
  data.splice(oldIndex, 1);
  data.splice(newIndex, 0, itemToMove);

  stepFormData.value.status = data
}

function getStatusTitle(id){
  return taskStatus.value?.find(el => el.id === id)?.title
}

function deleteStatus(index){
  stepFormData.value.status.splice(index, 1);
}


</script>

<style scoped>
.icon-wrapper {
  position: absolute;
  right: 12px;
  top: 50%;
  transform: translateY(-50%);
  display: flex;
  align-items: center;
  justify-content: center;
}

.icon-wrapper i {
  position: relative;
  font-size: 1.5em;
}

.icon-wrapper .icon-text {
  position: absolute;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 9px;
  color: white;
  margin-top: 8px;
}

.input-group>:not(:first-child):not(.dropdown-menu):not(.valid-tooltip):not(.valid-feedback):not(.invalid-tooltip):not(.invalid-feedback) {
  border-top-left-radius: .625rem !important;
  border-bottom-left-radius: .625rem !important;
}
</style>